import { Typography } from '@apostrophe/ui';
import PromoCode from 'components/payment/PromoCode';
import {
	createCartLineItems, dollarFormat
} from 'helpers/paymentHelpers';
import isEmpty from 'lodash/isEmpty';
import React from 'react';

import {
	formatCadenceCheckoutLineItems,
	formatLineItems, getTotalSavings, handleDoctorFeeDisclaimer
} from './Cart.helpers';
import CartItem from './CartItem';
import {
	AutoRefillIcon,
	ItemsContainer,
	OuterContainer,
	SavingsContainer,
} from './styles';

const Cart = ({
	state,
	lineItems,
	dispatcher,
	rxCredit,
	product_pre_purchase,
	medCheckout,
	isFreeVisit,
	isFollowupv2,
	isCadenceCheckout,
}) => {
	if (product_pre_purchase) {
		state.cart.product_pre_purchase = product_pre_purchase;
	}
	lineItems = lineItems || createCartLineItems(state,
		isCadenceCheckout);

	const autoRefillItems = lineItems.filter((item) => !isEmpty(item.autorefill));
	const hasAutoRefillOption = Boolean(autoRefillItems.length);
	const newLineItems = isCadenceCheckout ? formatCadenceCheckoutLineItems(lineItems,
		medCheckout): formatLineItems(lineItems,
		medCheckout);
	const totalAutoRefillDiscount = getTotalSavings(autoRefillItems);

	return (
		<div>
			{!isCadenceCheckout && !medCheckout && (
				<Typography variant="subtitle2">Order summary</Typography>
			)}
			<ItemsContainer isCadenceCheckout={isCadenceCheckout}>
				{newLineItems.map((lineItem, i) => (
					<CartItem
						key={i}
						index={i}
						medCheckout={medCheckout}
						{...lineItem}
						dispatcher={dispatcher}
					/>
				))}
				{/*Only show promo as Cart component item if pt is viewing v2 f/u checkout todo_remove_ar_cont*/}
				{!isFreeVisit && isFollowupv2 && (
					<div style={{ padding: '4px 16px' }}>
						<PromoCode
							isFollowupv2={isFollowupv2}
							medCheckout={true}
							state={state}
							dispatcher={dispatcher}
						/>
					</div>
				)}
				{hasAutoRefillOption ? (
					<OuterContainer>
						{!medCheckout && (
							<SavingsContainer>
								<div className="flex-start">
									<p>Savings with Auto Refill</p>
									<AutoRefillIcon />
								</div>
								<p>{dollarFormat(totalAutoRefillDiscount)}</p>
							</SavingsContainer>
						)}
					</OuterContainer>
				) : null}
				{handleDoctorFeeDisclaimer(state,
					rxCredit)}
			</ItemsContainer>
		</div>
	);
};

export default Cart;
